import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserIsActiveService {

  constructor(private httpService: HttpService, private authenticationSerice: AuthenticationService, private router: Router) { }

  checkUserIsActive() {
    this.httpService.checkUserIsAnonymous().subscribe((data) => {
      console.log(data);
      if (data['status']) {
        alert('Your aavin login is expired. please relogin.');
        this.authenticationSerice.logout();
        this.router.navigateByUrl('login');
      }
    }, (error) => {
      console.error(error['status']);
      let error_code = error['status'];
      console.log(error_code)
      if (error_code === 401) {
        alert('Your aavin login is expired. please relogin.');
        this.authenticationSerice.logout();
        this.router.navigateByUrl('login');
      }
    });
  }
}
